// extracted by mini-css-extract-plugin
module.exports = {"additionalDishList":"_1ULg-qScghYl3IPOgrJuH8","externalId":"pIcZsIpQr3WDtCSH6DFQI"};